import * as universal from '../entries/pages/_layout.js';

export const index = 0;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_layout.svelte.js')).default;
export { universal };
export const universal_id = "src/routes/+layout.js";
export const imports = ["_app/immutable/nodes/0.XQ_2FL12.js","_app/immutable/chunks/KZK0-soZ.js","_app/immutable/chunks/BZTNq1Um.js","_app/immutable/chunks/DW-TuIxf.js","_app/immutable/chunks/BGfRHZdV.js","_app/immutable/chunks/2mOfPPFS.js","_app/immutable/chunks/o-fdcMLv.js","_app/immutable/chunks/kwBiegc5.js"];
export const stylesheets = ["_app/immutable/assets/0.DRs2JxYa.css"];
export const fonts = [];
